angular.module("app").directive("colorStudyBubbleChart", () => {
  let link = (scope) => {
    scope.selectedColors = [];

    scope.$watch('data', function (data) {
      if (data) {
        scope.data = data;
        if (scope.data && scope.data.length > 0) {
          scope.selectedColors = [...scope.data];
        }
      }
    }, true);

    scope.selectColor = (color) => {
      if (!scope.isSelectedColor(color)) {
        scope.selectedColors = [...scope.selectedColors, color];
      }
      else {
        scope.selectedColors = scope.selectedColors.filter(item => item.hex !== color.hex);
      }
    };

    scope.isSelectedColor = (color) => {
      const res = scope.selectedColors.findIndex((item) => item.hex === color.hex);

      return res !== -1;
    };
    
    scope.$watch('selectedColors', function (selectedColors) {
      if (selectedColors) {
        scope.selectedColors = selectedColors;
        scope.bindData();
      }
    }, true);

    scope.bindData = () => {
      const element = document.getElementById(`my_color_study_bubble_chart_${scope.chartId}_dataviz`);
      if (element) {
        element.innerHTML = "";
      }

      const width = 600;
      const height = scope.height;

      const Nodes = [];

      for (let i = 0; i < scope.selectedColors.length; i++) { //
        const d = scope.selectedColors[i];
        Nodes.push(d);
      }

      const svg = d3
        .select(`#my_color_study_bubble_chart_${scope.chartId}_dataviz`)
        .append("svg")
        .attr("width", width)
        .attr("height", height);

      const bubble = d3.layout.pack()
        .size([width, height])
        .value(function(d) {
          return d.size;
        })
        .padding(-5);

      // generate data with calculated layout values
      const nodes = bubble.nodes(processData(Nodes))
        .filter(function(d) {
          return !d.children;
        }); // filter out the outer bubble

      //nodes for Bubbles are generated and a circle is appended.
      const node = svg.selectAll('circle').data(nodes);

      node.enter().append('circle')
        .attr('transform', function(d) {
          return 'translate(' + d.x + ',' + d.y + ')';
        })
        .attr('r', function(d) {
          return d.r;
        }) //(d.size *2); })
        .attr('fill', function(d) {
          return d.hex;
        })
        .style("stroke",function (d) {
          return d.hex === '#ffffff' || d.hex === '#FFFFFF' ?
            '#E0E0DD' : d.hex;
        });

      //Label of the name on the bubble
      const label = node.enter().append("text")
        .style("font-family", "Gotham SSm A, Gotham SSm B")
        .style("text-anchor", "middle")
        .style("font-size", function(d) {
          return d.r/2 ;
        })
        .style("fill", function (d) {
          return d.hex === '#000000' ? '#ffffff' : "#000000";
        })
        .text(function(d) {
          return d.size ;
        })
        .attr('transform', function(d) {
          return 'translate(' + d.x + ',' + (d.y + d.r/6) + ')';
        });
    }

    /*
     * The data is organized as name,color,size
     */
    function processData(data) {
      const obj = data;
      const newDataSet = [];
      for (const prop in obj) {
        if(obj[prop].count > 0){
          newDataSet.push({
            name: obj[prop].name,
            hex: obj[prop].hex,
            size: obj[prop].count
          });
        }
      }
      return {
        children: newDataSet
      };
    }
  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbColorStudyBubbleChart/dbColorStudyBubbleChartView.html",
    link: link,
    scope: {
      data: "=",
      chartId: "=",
      height: "=",
      boxHeight: "=",
    }
  };
});
